import {DateTime} from "luxon";

export function isGeoAllZero(geo) {
    return Array.isArray(geo) && geo.every(val => val === 0);
}

export function dateFormat(date) {
    const dt = DateTime.fromISO(String(date), {zone: 'Europe/London'});
    if (!dt.isValid) return '';
    return `${dt.toFormat('dd/MM/yy')} (${dt.toFormat('ccc').slice(0, 2)})`;
}

export function getDatesBetween(startDate, endDate) {
    let start = DateTime.fromISO(String(startDate), {zone: 'Europe/London'}).startOf('day');
    let end = DateTime.fromISO(String(endDate), {zone: 'Europe/London'}).startOf('day');
    if (!start.isValid || !end.isValid || start > end) return [];

    const dates = [];
    while (start <= end) {
        dates.push(`${start.toFormat('dd/MM/yy')} (${start.toFormat('ccc').slice(0, 2)})`);
        start = start.plus({days: 1});
    }
    return dates;
}

export function capitalizeFirst(value) {
    if (!value) return '';
    return value.charAt(0).toUpperCase() + value.slice(1);
}

export function isAdmin(){
    const me = this.$store.state.auth.me;
    return me.roles.includes('admin');
}

export function isGod(){
    const me = this.$store.state.auth.me;
    return me.roles.includes('admin');
}
export function isForeman(){
    const me = this.$store.state.auth.me;
    return me.roles.includes('foreman');
}

// Holders of this permission only ever see the hard ("Force") reopen/reset buttons, which post
// skip_fin=false and so bypass the finance export locks. Everyone else only ever sees the soft
// variants. It also gates the Dismiss All button, which bypasses finance in the same way.
// Enforced server side too - see UnifiedAdminTimesheetSubmissionController.
// Pull the API's own explanation out of a failed admin action. A soft reopen/reset against
// timesheets finance has already exported comes back as a 409 saying so and telling the user
// to escalate, so that text matters - never swallow it behind a generic message.
export function timesheetActionError(error, fallback){
    const data = error?.response?.data;
    return data?.error || data?.message || fallback;
}

// Snotify options for those messages: sticky, so an escalation instruction cannot be missed.
export const TIMESHEET_ACTION_ERROR_TOAST = {
    timeout: 0,
    showProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true
};

export function canForceTimesheetAction(){
    const me = this.$store.state.auth.me;
    return !!me && Array.isArray(me.permissions) && me.permissions.includes('sunset_timesheet_force_actions');
}

export function showAdminDetails(){
    const me = this.$store.state.auth.me;
    return me.roles.includes('foreman') || me.roles.includes('admin');
}